/**
 * これまでのレッスン動画（終えたDayの練習動画を見返す。2026-10-25 オーナー決定）
 *
 * トップには、今日の流れ（先生のコメント → 今日の練習）を主役のまま、下に小さなリンクとして置く。
 * Day1 の人（まだ終えたDayが無い）には出さない＝初めての人が見るトップは今までと同じ。
 * 見返す画面は見るだけ（録音・提出は無い）。先のDayは見せない（サーバーが lib/pastPracticeVideos.js で判定）。
 */

/** トップに「これまでのレッスン動画を見る」を出すか */
export function showPastLessonVideosLink({ requiredDataReady, currentDay }) {
  return requiredDataReady === true && Number.isInteger(currentDay) && currentDay >= 2
}
